import * as React from "react";
import styles from "./title.module.css";

interface IProps {
  children: React.ReactChild | React.ReactChild[];
}
export default function Title({ children }: IProps) {
  return <div className={styles.title}>{children}</div>;
}
